import React, { forwardRef } from 'react';

interface InfoProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const Info = forwardRef<HTMLElement, InfoProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-circle-info ${classes || ''}`} style={style}></i>
  );
});

Info.displayName = 'Info';
